// NOVAPAY-116-RC3-R2 — compact legal action cards (checkout / consent surfaces).
import type { StoreV2Lang } from "./store-v2-locale.js";

export function LegalActionCard({
  lang,
  icon,
  title,
  subtitle,
  onClick,
  testId,
}: {
  lang: StoreV2Lang;
  icon: string;
  title: string;
  subtitle: string;
  onClick: () => void;
  testId: string;
}) {
  return (
    <button
      type="button"
      className="sv2-legal-action-card"
      data-testid={testId}
      onClick={onClick}
      aria-label={`${title}. ${subtitle}`}
    >
      <span className="sv2-legal-action-card-icon" aria-hidden="true">
        {icon}
      </span>
      <span className="sv2-legal-action-card-text">
        <span className="sv2-legal-action-card-title">{title}</span>
        <span className="sv2-legal-action-card-sub">{subtitle}</span>
      </span>
      <span className="sv2-legal-action-card-chevron" aria-hidden="true">
        ›
      </span>
    </button>
  );
}

export function CheckoutLegalActionCards({
  lang,
  onOpenOffer,
  onOpenPrivacy,
}: {
  lang: StoreV2Lang;
  onOpenOffer: () => void;
  onOpenPrivacy: () => void;
}) {
  return (
    <div className="sv2-legal-action-card-list" data-testid="sv2-checkout-legal-actions">
      <LegalActionCard
        lang={lang}
        icon="📄"
        title={lang === "en" ? "Public offer" : "Публічна оферта"}
        subtitle={
          lang === "en"
            ? "Order, payment and delivery terms"
            : "Умови оформлення, оплати та доставки"
        }
        onClick={onOpenOffer}
        testId="sv2-checkout-legal-offer"
      />
      <LegalActionCard
        lang={lang}
        icon="🔒"
        title={lang === "en" ? "Privacy policy" : "Політика конфіденційності"}
        subtitle={
          lang === "en"
            ? "How we process and protect data"
            : "Як ми обробляємо та захищаємо дані"
        }
        onClick={onOpenPrivacy}
        testId="sv2-checkout-legal-privacy"
      />
    </div>
  );
}
